module.exports = __webpack_public_path__ + "static/site-1784739815621/img/bg-clouds.99cb0da3.png";